module.exports = __webpack_public_path__ + "img/home_index_left.f3f957bf.png";